import { render, staticRenderFns } from "./pendaftaran_objek_pajak_baru.vue?vue&type=template&id=99aa134c&"
import script from "./pendaftaran_objek_pajak_baru.vue?vue&type=script&lang=js&"
export * from "./pendaftaran_objek_pajak_baru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports